export { CommonTable } from './CommonTable';
